import { css } from '@emotion/css';

export const audioStyles = css`
  background: #674af8;
  width: 100%;
  min-width: 28rem;
  height: 41rem;
`;

export const imageStyles = css`
  height: 54.2rem;
`;
